import { Box, Separator, Text } from '@bechtel/gds';
import { map } from 'lodash';
import { FC, useContext, useEffect, useMemo, useState } from 'react';
import { ErrorBoundary } from '~/components';
import { SearchField } from '~/components/search-field';
//@ts-ignore images ignore
import { ReactComponent as EmptyStateBox } from '~/images/empty-state-box.svg';
import { ReturnToolContext, ToolInventoryWithQuantity } from '../return-tool-context';
import { actionType } from '../types';
import ReturnToolSectionHeader from './Header';
import { default as ReturnSectionListWrapper } from './Wrapper';
import { ReturnToolListSectionStyled, SearchAreaStyled } from './styled';
import { ReturnToolListProps } from './type';

export const ReturnToolList: FC<ReturnToolListProps> = ({
  serialisedTools,
  consumerableTools,
  onSearch,
  isExistingOrder,
}) => {
  const [isSerialisedOpen, setIsSerialisedOpen] = useState<boolean>(false);
  const [isConsumbleOpen, setIsConsumbleOpen] = useState<boolean>(false);
  const { updateData } = useContext(ReturnToolContext);

  const existingToolList = useMemo(() => {
    const toolInventoryList = [
      ...map(serialisedTools, (item) => ({
        ...item.toolInventory,
        quantity: item.dispatchQuantity,
      })),
      ...map(consumerableTools, (item) => ({
        ...item.toolInventory,
        quantity: item.dispatchQuantity,
      })),
    ];

    return toolInventoryList as ToolInventoryWithQuantity[];
  }, [consumerableTools, serialisedTools]);

  useEffect(() => {
    if (isExistingOrder && updateData) {
      updateData(actionType.ADD, {
        checkInToolList: existingToolList,
      });
    }
  }, [existingToolList, isExistingOrder]);

  return (
    <ErrorBoundary>
      <ReturnToolListSectionStyled>
        <SearchAreaStyled>
          <SearchField
            placeholder="Search"
            onChange={(event) => {
              onSearch(event.target.value);
            }}
          ></SearchField>
        </SearchAreaStyled>
        <Separator spacing="000" color="grey.300" />
        <Box style={{ overflowY: 'auto', height: 'calc(100vh - 170px)' }} flexDirection={{ sm: 'column' }}>
          {serialisedTools && serialisedTools?.length > 0 && (
            <>
              <ReturnToolSectionHeader
                isOpen={isSerialisedOpen}
                setIsOpen={setIsSerialisedOpen}
                title="Serialized Tools"
                count={serialisedTools.length}
                hideAllAction={false}
                hideCount={true}
                checkinToolList={serialisedTools}
              />
              <ErrorBoundary>
                <ReturnSectionListWrapper isOpen={isSerialisedOpen} list={serialisedTools} hideCount={true} />
              </ErrorBoundary>
            </>
          )}
          {consumerableTools && consumerableTools?.length > 0 && (
            <>
              <ReturnToolSectionHeader
                isOpen={isConsumbleOpen}
                setIsOpen={setIsConsumbleOpen}
                title="Consumables"
                count={consumerableTools.length}
                hideAllAction={true}
                hideCount={false}
                checkinToolList={consumerableTools}
              />
              <ErrorBoundary>
                <ReturnSectionListWrapper isOpen={isConsumbleOpen} list={consumerableTools} hideCount={false} />
              </ErrorBoundary>
            </>
          )}
          {serialisedTools?.length == 0 && consumerableTools?.length == 0 && (
            <Box
              px={{ sm: '500' }}
              py={{ sm: '500' }}
              alignItems={{ sm: 'center' }}
              justifyContent={{ sm: 'center' }}
              style={{ flex: '1' }}
              flexDirection={{ sm: 'column' }}
              gap={{ sm: '500' }}
            >
              <EmptyStateBox />

              <Text color="grey.1000" size="400">
                No serialized / Non-serialized tool found.
              </Text>
            </Box>
          )}
        </Box>
      </ReturnToolListSectionStyled>
    </ErrorBoundary>
  );
};
